var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.prevPageIsHome)?_c('x-float-ad',{attrs:{"image":require('./images/更多好物.png'),"track":{
    name: '更多好物',
    id: 'bbc3501f-300c-454a-b34d-e0d6c9ca4e3b',
  }},on:{"click":_vm.handleClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }